define('drops/drawings/businessprocessEvents',['jquery','underscore'],
    function ($, _) {
        'use strict';

        function BusinessProcessEvents() {
            this.eventRegistrations = {};
        }

        BusinessProcessEvents.prototype.addListener = function (event, listener, optionalOwner) {
            if (!this.eventRegistrations[event])
                this.eventRegistrations[event] = [];
            this.eventRegistrations[event].push({
                listener: listener,
                owner: optionalOwner
            });
        };

        BusinessProcessEvents.prototype.removeListener = function (event, owner) {
            var registrations = this.eventRegistrations[event];
            var registration = _.findWhere(registrations, { owner: owner });
            if (registration) {
                var index = registrations.indexOf(registration);
                registrations.splice(index, 1);
            }
        };

        BusinessProcessEvents.prototype.informListeners = function (event) {
            if (!this.eventRegistrations[event])
                return;

            var args = Array.prototype.slice.call(arguments, 1);
            _.forEach(this.eventRegistrations[event], function (registration) {
                registration.listener.apply(null, args);
            });
        };

        return new BusinessProcessEvents();
    });

